/*
 * Пустое состояние. Из макета два вида: с одним действием («Чтобы вести запись,
 * добавьте хотя бы одного мастера») и без действия, когда прав на действие нет
 * («Салон ещё настраивается»).
 */

.empty {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-2);
  padding: 22px 18px;
  background: var(--bg-workspace);
  border: 1px dashed var(--border-strong);
  border-radius: var(--radius-lg);
  min-width: 0;
}

/* Без действия плашка ниже: ей нечего предлагать, и занимать место незачем. */
.quiet {
  padding: 16px 18px;
  gap: 6px;
}

.title {
  margin: 0;
  font-size: 14px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  text-wrap: pretty;
}

.quiet .title {
  font-size: var(--font-size-base);
}

.text {
  margin: 0;
  font-size: var(--font-size-md);
  line-height: 1.5;
  color: var(--text-secondary);
  text-wrap: pretty;
}

.action {
  margin-top: var(--space-1);
  max-width: 100%;
}
